module.exports = __webpack_public_path__ + "img/case34.35deac91.png";